import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import "../circleloader_vars.css";
import $jmyJ1$circleloader_vars_cssmjs from "../circleloader_vars_css.mjs";
import {useDOMRef as $3c2c983d5210446c$export$c2c55ef9111cafd8} from "../utils/useDOMRef.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {clamp as $jmyJ1$clamp} from "react-stately/private/utils/number";
import $jmyJ1$react from "react";
import {useProgressBar as $jmyJ1$useProgressBar} from "react-aria/useProgressBar";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 






const $1cfe37e7feefa23d$export$c79b9d6b4cc92af7 = /*#__PURE__*/ (0, $jmyJ1$react).forwardRef(function ProgressCircle(props, ref) {
    let { value: value = 0, minValue: minValue = 0, maxValue: maxValue = 100, size: size = 'M', staticColor: staticColor, variant: variant, isIndeterminate: isIndeterminate = false, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, ...otherProps } = props;
    let domRef = (0, $3c2c983d5210446c$export$c2c55ef9111cafd8)(ref);
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(otherProps);
    value = (0, $jmyJ1$clamp)(value, minValue, maxValue);
    let { progressBarProps: progressBarProps } = (0, $jmyJ1$useProgressBar)({
        ...props,
        value: value
    });
    let subMask1Style = {};
    let subMask2Style = {};
    if (!isIndeterminate) {
        let percentage = (value - minValue) / (maxValue - minValue) * 100;
        let angle;
        if (percentage > 0 && percentage <= 50) {
            angle = -180 + percentage / 50 * 180;
            subMask1Style.transform = `rotate(${angle}deg)`;
            subMask2Style.transform = 'rotate(-180deg)';
        } else if (percentage > 50) {
            angle = -180 + (percentage - 50) / 50 * 180;
            subMask1Style.transform = 'rotate(0deg)';
            subMask2Style.transform = `rotate(${angle}deg)`;
        }
    }
    if (!ariaLabel && !ariaLabelledby && process.env.NODE_ENV !== 'production') console.warn('ProgressCircle requires an aria-label or aria-labelledby attribute for accessibility');
    return /*#__PURE__*/ (0, $jmyJ1$react).createElement("div", {
        ...styleProps,
        ...progressBarProps,
        ref: domRef,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jmyJ1$circleloader_vars_cssmjs))), 'spectrum-CircleLoader', {
            'spectrum-CircleLoader--indeterminate': isIndeterminate,
            'spectrum-CircleLoader--small': size === 'S',
            'spectrum-CircleLoader--large': size === 'L',
            'spectrum-CircleLoader--overBackground': variant === 'overBackground',
            'spectrum-CircleLoader--staticWhite': staticColor === 'white',
            'spectrum-CircleLoader--staticBlack': staticColor === 'black'
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $jmyJ1$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jmyJ1$circleloader_vars_cssmjs))), 'spectrum-CircleLoader-track')
    }), /*#__PURE__*/ (0, $jmyJ1$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jmyJ1$circleloader_vars_cssmjs))), 'spectrum-CircleLoader-fills')
    }, /*#__PURE__*/ (0, $jmyJ1$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jmyJ1$circleloader_vars_cssmjs))), 'spectrum-CircleLoader-fillMask1')
    }, /*#__PURE__*/ (0, $jmyJ1$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jmyJ1$circleloader_vars_cssmjs))), 'spectrum-CircleLoader-fillSubMask1'),
        "data-testid": "fillSubMask1",
        style: subMask1Style
    }, /*#__PURE__*/ (0, $jmyJ1$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jmyJ1$circleloader_vars_cssmjs))), 'spectrum-CircleLoader-fill')
    }))), /*#__PURE__*/ (0, $jmyJ1$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jmyJ1$circleloader_vars_cssmjs))), 'spectrum-CircleLoader-fillMask2')
    }, /*#__PURE__*/ (0, $jmyJ1$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jmyJ1$circleloader_vars_cssmjs))), 'spectrum-CircleLoader-fillSubMask2'),
        "data-testid": "fillSubMask2",
        style: subMask2Style
    }, /*#__PURE__*/ (0, $jmyJ1$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jmyJ1$circleloader_vars_cssmjs))), 'spectrum-CircleLoader-fill')
    })))));
});


export {$1cfe37e7feefa23d$export$c79b9d6b4cc92af7 as ProgressCircle};
//# sourceMappingURL=ProgressCircle.mjs.map
